import networkService from '../../Network/NetworkManager';
import {getAppRoutePath, getMenuHref, isIframeAppMenu} from '../appRoutes';

const APPURL = require('../../Constants/URLConstants');

// Records a sidebar click in Skua's onboarding_events (flow 'superadmin_menu') so a tenant's
// path from signup to the features they use can be read from our own DB. Fire and forget.
const toKey = value =>
  String(value || '')
    .replace(/[^A-Za-z0-9_.-]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 100);

const trackMenuClick = (menu, parentMenu = null) => {
  const step = toKey(menu?.key_name || menu?.href || menu?.title);
  if (!step) {return;}
  networkService
    .networkCall(
      APPURL.URLPaths.onboardingEvents,
      'POST',
      JSON.stringify({
        flow: 'superadmin_menu',
        step,
        action: 'clicked',
        data: {
          href: menu?.href || null,
          // where the click leads: the in-app route (iframe apps) or the menu link, and the app URL behind it
          route: isIframeAppMenu(menu) ? getAppRoutePath(menu) : menu?.href || null,
          url: getMenuHref(menu) || menu?.iframe_url || null,
          parent: parentMenu?.key_name || null,
          path: window.location.pathname,
        },
      }),
    )
    .catch(() => {});
};

export default trackMenuClick;
